import axios from "axios";
import { CONFIG } from "../config";

export const updateTourSealNumbers = async (authParams) => {
  const { clientId, authToken, data } = authParams;
  const config = {
    method: "PUT",
    url: `${
      CONFIG.LOCUS_API?.[`LILY_BASE_URL_${clientId}`]
    }/client/${clientId}/tour/`,
    headers: { Authorization: `Bearer ${authToken}` },
    data,
  };

  return new Promise((resolve) => {
    axios(config)
      .then((response) => {
        resolve({
          status: true,
          code: response.status,
          data: response?.data,
        });
      })
      .catch(({ response = {} }) => {
        resolve({
          status: false,
          code: response.status,
          data: response?.data,
        });
      });
  });
};
